import React, {useState} from 'react';
import moment from 'moment';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CalendarIcon from '@mui/icons-material/CalendarToday';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import Divider from '@mui/material/Divider';
// import Form from '@mui/material/Form';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

import DateField from './DateField';

const DateFilterForm = props => {
  const [startDate, setStartDate] = useState(props.startDate);
  const [endDate, setEndDate] = useState(props.endDate);
  const handleSubmit = e => props.onSubmit(e, {startDate,endDate});
  return (
    <Grid container spacing={1} padding={1}>
      <Grid item xs={12} md={6}>
        <DateField
          label='Start Date'
          fullWidth
          maxDate={moment(endDate)}
          value={moment(startDate)}
          onChange={e => {
            setStartDate(moment(e.target.value).startOf('day').toISOString())
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <DateField
          label='End Date'
          fullWidth
          minDate={moment(startDate)}
          value={moment(endDate)}
          onChange={e => setEndDate(moment(e.target.value).endOf('day').toISOString())}
        />
      </Grid>
      <Grid item xs={6} md='auto'>
        <Stack direction={'row'} spacing={1}>
          <Button 
            onClick={e => {
              const start = moment().startOf('day').toISOString();
              const end = moment().endOf('day').toISOString();
              setStartDate(start);
              setEndDate(end);
              props.onSubmit(e, {startDate: start, endDate: end});
            }}
            variant='outlined' 
            color='primary'
            size='small'
          >
            Today
          </Button>
          <Button 
            onClick={e => {
              const start = moment().startOf('day').subtract(1, 'days').toISOString();
              const end = moment().endOf('day').subtract(1, 'days').toISOString();
              setStartDate(start);
              setEndDate(end);
              props.onSubmit(e, {startDate: start, endDate: end});
            }}
            variant='outlined' 
            color='primary'
            size='small'
          >
            Yesterday
          </Button>
          <Button 
            onClick={e => {
              const start = moment().add(1, 'days').startOf('day').toISOString();
              const end = moment().add(1, 'days').endOf('day').toISOString();
              setStartDate(start);
              setEndDate(end);
              props.onSubmit(e, {startDate: start, endDate: end});
            }}
            variant='outlined' 
            color='primary'
            size='small'
          >
            Tomorrow
          </Button>
        </Stack>
        <Stack direction='row' spacing={1} paddingTop={1}>
          <Button
            onClick={e => {
              // make weeks start on Monday
              const start = moment().startOf('week').add(1, 'days').toISOString();
              const end = moment().endOf('week').add(1, 'days').toISOString();
              setStartDate(start);
              setEndDate(end);
              props.onSubmit(e, {startDate: start, endDate: end});
            }}
            variant='outlined' 
            color='primary'
            size='small'
          >
            This Week
          </Button>
          <Button
            onClick={e => {
              // make weeks start on Monday
              const start = moment().startOf('week').subtract(6, 'days').toISOString();
              const end = moment().endOf('week').subtract(6, 'days').toISOString();
              setStartDate(start);
              setEndDate(end);
              props.onSubmit(e, {startDate: start, endDate: end});
            }}
            variant='outlined' 
            color='primary'
            size='small'
          >
            Last Week
          </Button>
          <Button
            onClick={e => {
              // make weeks start on Monday
              const start = moment().startOf('week').add(8, 'days').toISOString();
              const end = moment().endOf('week').add(8, 'days').toISOString();
              setStartDate(start);
              setEndDate(end);
              props.onSubmit(e, {startDate: start, endDate: end});
            }}
            variant='outlined' 
            color='primary'
            size='small'
          >
            Next Week
          </Button>
        </Stack>
      </Grid>
      {
        props.includeMonthOptions &&
        <Grid item xs={12} md={12}>
          <Stack direction='row' spacing={1} paddingTop={1}>
            <Button
              onClick={e => {
                const start = moment().startOf('month').subtract(7, 'days').startOf('month').toISOString();
                const end = moment().startOf('month').toISOString();
                setStartDate(start);
                setEndDate(end);
                props.onSubmit(e, {startDate: start, endDate: end});
              }}
              variant='outlined' 
              color='primary'
              size='small'
            >
              Last Month
            </Button>
            <Button
              onClick={e => {
                const start = moment().startOf('month').toISOString();
                const end = moment().endOf('month').toISOString();
                setStartDate(start);
                setEndDate(end);
                props.onSubmit(e, {startDate: start, endDate: end});
              }}
              variant='outlined' 
              color='primary'
              size='small'
            >
              This Month
            </Button>
          </Stack>
        </Grid>
      }
      <Grid item xs={12} md={12}>
        <Box>
          <Button 
            variant='contained' 
            color='primary'
            onClick={handleSubmit}>
            Apply
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

const DateFilterDialog = props => {
  const title = 'Apply Date Filter';
  return (
    <>
      <Dialog
        open={props.open}
        fullWidth={true}
        maxWidth='sm'
        onClose={props.onClose}
      >
        <Grid container spacing={2} padding={2}>
          <Grid item xs={12} md={12} style={{paddingBottom: '0.25em'}}>
            <Stack direction='row' justifyContent='space-between' alignItems='center'>
              <Typography variant='h2'>{title}</Typography>
              <IconButton onClick={props.onClose}>
                <CloseIcon/>
              </IconButton>
            </Stack>
            <Divider style={{marginBottom: '1.5rem'}}/>
            <DateFilterForm {...props} />
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

const DateRangeFilter = props => {
  const [isOpen, setIsOpen] = useState(false);
  const [isApplied, setIsApplied] = useState(false);
  const childProps = {
    ...props,
    defaultStartDate: props.start_date,
    defaultEndDate: props.end_date,
    color: props.isActive ? 'secondary' : 'primary',
    size: 'small',
    open: isOpen,
    onSubmit: (e, {startDate, endDate}) => {
      props.onSubmit(e, {startDate, endDate});
      setIsApplied(true);
      setIsOpen(false);
    },
    onClose: () => {
      setIsOpen(false);
    },
  };
  const label = props?.label || 'Filter by Dates';
  const onClick = e => {
    if (isApplied) {
      props.onSubmit(e, {startDate: undefined, endDate: undefined});
      setIsApplied(false);
      return;
    }
    setIsOpen(true);
  };
  return (
    <>
      {props.iconOnly
        ? <Tooltip title={label}>
          <IconButton 
            {...childProps}
            onClick={onClick}
          >
            <CalendarIcon/>
          </IconButton>
        </Tooltip>
        : <Button {...childProps} onClick={onClick}>
            {label}
          </Button>
        }
        <DateFilterDialog {...childProps} />
    </>
  );
};

export default DateRangeFilter;